export enum TypePlayer {
    PLAYER='player',
    AGENT='agent',
    BOARD='board',
    VIDEO='video'
}